exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trax-form-control-select[data-v-0e9fb943] li.disabled span.material-icons {\n    display: none !important;\n}\n.trax-form-control-select[data-v-0e9fb943] .dropdown-menu.show {\n    max-width: 350px !important;\n}\n\n", ""]);

// exports
